import axios, { AxiosRequestConfig } from 'axios';

const baseConfig: AxiosRequestConfig = {
   baseURL: import.meta.env.VITE_APP_API_BASE_URL,
   headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
   },
};

const api = axios.create(baseConfig);

api.interceptors.response.use((config) => {
   const PREVIOUS_VERSION = localStorage.getItem('version');

   const CURRENT_VERSION = config.headers?.['x-api-version'];
   if (!CURRENT_VERSION) return config;

   localStorage.setItem('version', CURRENT_VERSION);

   if (!PREVIOUS_VERSION && !CURRENT_VERSION) return config;

   if (PREVIOUS_VERSION !== CURRENT_VERSION) window.location.reload();
   return config;
});

export { api };
